import { useContext, useEffect, useRef } from "react";
import { UserDevicesContext } from "../context/UserDevicesContext";
import { CapacitorContext } from "../context/CapacitorContext";
import { Device } from "@capacitor/device";

const getDeviceDisplayName = async (platform) => {
  if (platform !== "web") {
    try {
      const info = await Device.getInfo();
      const parts = [info.manufacturer, info.model].filter(Boolean);
      return parts.join(" ").trim() || "Dispositivo";
    } catch {
      return "Dispositivo";
    }
  }
  return navigator.platform || "Web";
};

const usePushNotifications = () => {
  const { platform, registered, device_token, registerNotifications } =
    useContext(CapacitorContext);
  const { user_devices, setUserDevice, getUserDevices, saveUserDevice } =
    useContext(UserDevicesContext);

  const handledRef = useRef(false);

  useEffect(() => {
    getUserDevices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (platform !== "web") registerNotifications(platform);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platform]);

  useEffect(() => {
    if (Array.isArray(user_devices) && device_token !== null && !handledRef.current) {
      handledRef.current = true;
      handleUserDevice(user_devices, device_token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [device_token, user_devices]);

  const handleUserDevice = async (devices, token) => {
    const index = devices.findIndex((d) => d.token === token);
    if (index !== -1) {
      setUserDevice(devices[index]);
    } else {
      const nombre = await getDeviceDisplayName(platform);
      saveUserDevice({ nombre, token, activo: true });
    }
  };

  return { registered, device_token };
};

export default usePushNotifications;
